/*
创建者 左晨(2019.07.24)
支付页面
*/
<template>
  <div>
    <div class="header">
      <img
        src="../../assets/images/account_logo.png"
        width="200"
      >
    </div>
    <div class="cz-con">
      <div class="inner">
        <h2>充值</h2>
        <div class="content">
          <form
            action="api/user/transfer?tokenId=798cc3d3-56b0-44b2-848a-a3d6d306f253"
            name="transferForm"
            class="alipayform"
            method="POST"
            target="_blank"
          >
            <div class="element">
              <div class="etitle">充值金额:</div>
              <div class="einput"><input
                  type="text"
                  id="WIDtotal_fee"
                  name="WIDtotal_fee"
                  value="10"
                  v-model="payModel"
                ></div>
              <br>
              <div class="mark">注意：付款金额，必填(格式如：1,1元的整数倍)</div>
            </div>
            <div
              class="element"
              style="display: none"
            >
              <input
                type="text"
                id="tokenId"
                name="tokenId"
                value="798cc3d3-56b0-44b2-848a-a3d6d306f253"
              >
            </div>
            <div class="element">
              <input
                class="alisubmit"
                @click="aliPay"
                type="button"
                value="使用支付宝充值"
              >
              <!-- <input class="wxsubmit" @click="wxPay" type="button" value="使用微信充值"> -->
            </div>
          </form>
        </div>
      </div>
    </div>

    <div
      id="forms"
      style="display: none"
    ></div>
  </div>

</template>
<script>
import { investAccount } from "api/user";
export default {
  data() {
    return {
      payModel: "",
    };
  },
  mounted() {
    this.$nextTick(function () {
      this.payModel = "";
    });
  },
  methods: {
    aliPay() {
      if (this.payModel === "") {
        this.$Message.warning("请输入充值金额！");
        return;
      }
      let place = String(this.payModel).indexOf(".") + 1;
      // if(place > 0){
      //      this.$Message.warning('不能输入小数金额，请输入整数！');
      //      return;
      // }
      if (this.payModel.length > 9) {
        this.$Message.warning("数据超限，请输入实际金额！");
        return;
      }
      let self = this;
      layer.confirm(
        "是否确定充值?",
        {
          btn: ["确定", "取消"],
        },
        function () {
          let data = {
            money: self.payModel,
            payType: 3,
            tradeType: "NATIVE",
            type: 1,
          };
          investAccount(data).then((res) => {
            if (res.resCode === 1) {
              layer.msg("成功", { icon: 1 });
              if (res.data.payWay === "ADAPAY_ALIPAY_COMMON") {
                let payUrl = JSON.parse(res.data.payData).expend.qrcode_url;
                self.$router.push({
                  path: "/aliPage",
                  query: {
                    payUrl: payUrl,
                    totalAmount: self.payModel,
                    payType: "recharge", //积分充值
                    queryUrl: JSON.parse(res.data.payData).query_url,
                  },
                });
              } else {
                document.getElementById("forms").innerHTML = res.data.payData;
                document.forms[1].submit();
              }
            } else {
              layer.msg(res.resDesc, { icon: 2 });
              return;
            }
          });
        },
        function () {}
      );
    },
    wxPay() {
      console.log();
      if (this.payModel == "") {
        this.$Message.warning("请输入充值金额！");
        return;
      }
      let place = String(this.payModel).indexOf(".") + 1;
      if (this.payModel.length > 9) {
        this.$Message.warning("数据超限，请输入实际金额！");
        return;
      }
      let self = this;
      layer.confirm(
        "是否确定充值?",
        {
          btn: ["确定", "取消"],
        },
        function () {
          let data = {
            money: self.payModel,
            payType: 2,
            tradeType: "NATIVE",
            type: 1,
          };
          investAccount(data).then((res) => {
            if (res.resCode === 1) {
              layer.msg("成功", { icon: 1 });
              let payUrl = res.data.payUrl;
              self.$router.push({
                path: "/weixinPage",
                query: {
                  payUrl: payUrl,
                  totalAmount: self.payModel,
                  payType: "recharge", //积分充值
                },
              });
            } else {
              // 返回不成功
              layer.msg(res.resDesc, { icon: 2 });
            }
          });
        },
        function () {}
      );
    },
  },
};
</script>
<style lang="less">
@import "../../assets/css/showAlipay.less";
</style>



// WEBPACK FOOTER //
// showAlipay.vue?29b180a6